import React from 'react'
import Group from 'components/utils/Group'
import TextButton from 'components/Luxkit/Button/TextButton'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import useCheapestOfTourV2Offer from 'hooks/TourV2/useCheapestOfTourV2Offer'
import useTourV2PurchasableOptionDetails from 'hooks/TourV2/useTourV2PurchasableOptionDetails'
import useTourV2VariationDetails from 'hooks/TourV2/useTourV2VariationDetails'
import PriceRowPriceCaption from 'components/Luxkit/PricePoints/PriceRowPriceCaption'
import PriceRowTaxesAndFees from 'components/Luxkit/PricePoints/PriceRowTaxesAndFees'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import PriceRowAgentHubCommission from 'agentHub/components/PriceRowAgentHubCommission'
import PriceRowValueDiscountWithCaption from 'components/Luxkit/PricePoints/Value/PriceRowValueDiscountWithCaption'
import PriceRowCaption from 'components/Luxkit/PricePoints/PriceRowCaption'
import LuxuryPlusPriceStack from 'loyalty/components/LuxuryPlusPriceStack'

interface Props {
  offer: Tours.V2Offer | Tours.V2OfferSummary;
  className?: string;
}

function TourV2PriceDetails(props: Props) {
  const { offer } = props

  const {
    cheapestPurchasableOption,
    cheapestVariation,
  } = useCheapestOfTourV2Offer(offer)

  const {
    durationInDaysCount,
  } = useTourV2VariationDetails(cheapestVariation)

  const {
    pricePerPerson,
    roomTypeName,
    valuedAt,
    memberPrice,
  } = useTourV2PurchasableOptionDetails(cheapestPurchasableOption) || {}
  return (
    <Group direction="horizontal" horizontalAlign="space-between" verticalAlign="end">
      <VerticalSpacer gap={8}>
        <div>
          {pricePerPerson &&
            <>
              <PriceRowPriceCaption>{durationInDaysCount} from</PriceRowPriceCaption>
              <LuxuryPlusPriceStack
                size="L"
                price={Number(pricePerPerson)}
                saleUnit="person"
                memberPrice={Number(memberPrice)}
                isTour
              />
              <PriceRowTaxesAndFees />
            </>
          }
          {valuedAt && <PriceRowValueDiscountWithCaption
            data-testid="value-box"
            size="L"
            value={Math.ceil(valuedAt.price)}
            discountPercentage={valuedAt.savingPercentage}
          />}
          <PriceRowCaption>{roomTypeName}</PriceRowCaption>
          <PriceRowTaxesAndFees />
        </div>
        <PriceRowAgentHubCommission
          size="L"
          productType={offer.productType}
        />
      </VerticalSpacer>
      <CSSBreakpoint min="desktop">
        <TextButton kind="primary" nonInteractable>
          View
        </TextButton>
      </CSSBreakpoint>
    </Group>
  )
}

export default TourV2PriceDetails
